import LottieAnimation from '@base/LottieAnimation/LottieAnimation';
import { emptyObject } from '@constants/empty';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { getAnimationPath } from '@utils/animationHelpers';
import Typography from 'aquilla/core/atoms/Typography';
import { useState } from 'react';
import { numberFormatter } from '../constants';
import HallOfFameDialog from './HallOfFameDialog';
import HallOfFameList from './HallOfFameList';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6B};
`;

const SubTitle = styled(Typography)`
  color: var(--color-text-secondary);
`;

const WinnerImageWrapper = styled.div`
  height: ${Spacings.SPACING_4B};
  width: ${Spacings.SPACING_10B};
  position: relative;
`;

const AnimationContainer = styled(LottieAnimation)`
  width: ${Spacings.SPACING_10B};
  height: ${Spacings.SPACING_4B};
  flex-shrink: ${Spacings.SPACING_0B};
`;

const SubTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_6};
`;

const CardDetailsWrapper = styled.div`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_0B} ${Spacings.SPACING_0B};
  border: ${Spacings.SPACING_1} solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
`;

const HallOfFameContainer = ({ hallOfFame, segmentData, goalSegmentData }) => {
  const [openDialog, setOpenDialog] = useState(false);
  if (!Object.keys(hallOfFame).length) return null;
  const {
    extraBlockInfo: {
      totalVoucherRewardThisMonth = emptyObject,
      totalRewardWinnersThisMonth = emptyObject,
      totalRewardWinnersLastMonth = emptyObject,
      totalVoucherRewardLastMonth = emptyObject
    } = emptyObject,
    data: hallOfFameData = emptyObject
  } = hallOfFame;
  const showEmpty = hallOfFameData.length < 2;

  return (
    <Container>
      <InfoWrapper>
        <Typography variant="h4">Monthly hall of fame</Typography>
        <SubTitleWrapper>
          <WinnerImageWrapper>
            <AnimationContainer
              src={getAnimationPath('goalPage/joiningMembers.json')}
            />
          </WinnerImageWrapper>
          <SubTitle variant="p3">
            ₹
            {numberFormatter(
              showEmpty
                ? totalVoucherRewardLastMonth
                : totalVoucherRewardThisMonth
            )}{' '}
            awarded to{' '}
            {numberFormatter(
              showEmpty
                ? totalRewardWinnersLastMonth
                : totalRewardWinnersThisMonth
            )}{' '}
            learners {showEmpty ? 'last month' : 'this month'}
          </SubTitle>
        </SubTitleWrapper>
      </InfoWrapper>
      <CardDetailsWrapper>
        <HallOfFameList
          setOpenDialog={setOpenDialog}
          hallOfFameData={hallOfFameData}
          segmentData={segmentData}
          goalSegmentData={goalSegmentData}
        />
      </CardDetailsWrapper>
      {openDialog && (
        <HallOfFameDialog
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          hallOfFameData={hallOfFameData}
        />
      )}
    </Container>
  );
};
export default HallOfFameContainer;
